import React from 'react';
import { ChevronDown } from 'lucide-react';

interface FAQProps {
  showAll?: boolean;
}

export function FAQ({ showAll = false }: FAQProps) {
  const questions = [
    {
      question: "How will your headlines help me stand out from my competitors?",
      answer: "Our AI analyzes your competitors' copy and identifies unique angles that will make your headlines more compelling and distinctive. We focus on emotional triggers and value propositions that resonate with your specific audience."
    },
    {
      question: "Who are the 4U headers suitable for?",
      answer: "4U headers work for any business looking to improve their conversion rates. Whether you're running an e-commerce store, SaaS platform, or service business, our AI adapts the analysis to your specific industry and audience."
    },
    {
      question: "Can I customize the header to suit my needs?",
      answer: "Absolutely! Our AI provides suggestions that you can modify and adapt to match your brand voice and specific requirements. You maintain full creative control while benefiting from data-driven insights."
    },
    {
      question: "Is this only suitable for the main header of my site?",
      answer: "No, our analysis covers all crucial copy elements including main headlines, subheadings, CTAs, product descriptions, and more. We help optimize your entire conversion funnel."
    },
    {
      question: "How can 4U headlines help increase revenue?",
      answer: "4U headlines are scientifically designed to grab attention, create urgency, highlight unique value, and address user needs. This comprehensive approach typically leads to higher engagement and conversion rates."
    }
  ];

  const displayedQuestions = showAll ? questions : questions.slice(0, 5);

  return (
    <section className="py-16 px-4">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-2xl font-bold mb-8 text-center">
          Questions & Answers
        </h2>
        <div className="space-y-4">
          {displayedQuestions.map((item, index) => (
            <details
              key={index}
              className="group border rounded-xl overflow-hidden bg-white"
            >
              <summary className="flex justify-between items-center p-6 cursor-pointer hover:bg-gray-50">
                <span className="font-medium pr-8">
                  {String(index + 1).padStart(2, '0')} {item.question}
                </span>
                <ChevronDown className="w-5 h-5 flex-shrink-0 transition-transform group-open:rotate-180" />
              </summary>
              <div className="p-6 bg-gray-50 border-t">
                <p className="text-gray-600">{item.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}